import { StyleSheet } from 'aphrodite/no-important';

import colors from '../identity/colors';
import zIndex from '../identity/zIndex';
import screens from '../identity/screenSizes';

const LOGO_HEIGHT_DESKTOP = 65;
const LOGO_HEIGHT_TABLET = 50;
const LOGO_HEIGHT_MOBILE = 40;
const LOGO_TOP_DESKTOP = 72;
const LOGO_TOP_TABLET = 40;
const LOGO_TOP_MOBILE = 15;

export default StyleSheet.create({
  main: {
    overflow: 'hidden',
    position: 'relative',
  },
  
  active: {
    color: '#4267B2 !important',
    opacity: 1,
  },

  activeLi: {
    borderColor: '#4267B2 !important',
    transition: 'border-right-color 350ms ease-out .5s, opacity 350ms ease-out .5s',
  },

  appContainer: {
    backgroundColor: colors.WHITE,
    position: 'relative',
    zIndex: zIndex.main,
  },

  project: {
    position: 'relative',
  },

  link: {
    display: 'block',
    position: 'absolute',
    top: 0,
    width: '100%',
    marginTop: '-360px',
  },

  footerSpacer: {
    height: '50vh',
    minHeight: '500px',
  },

  heroContainer: {
    position: 'relative',
    zIndex: zIndex.header,
  },

  logoContainer: {
    position: 'absolute',
    bottom: 0,
    right: '110px',
    top: LOGO_TOP_DESKTOP,
    height: LOGO_HEIGHT_DESKTOP,

    [screens.TABLET]: {
      right: '60px',
      top: LOGO_TOP_TABLET,
      height: LOGO_HEIGHT_TABLET,
    },

    [screens.MOBILE]: {
      right: '20px',
      top: LOGO_TOP_MOBILE,
      height: LOGO_HEIGHT_MOBILE,
    },
  },

  header_gradient: {
    background: 'linear-gradient(to bottom, rgba(29,33,41,0.5) 0%,rgba(29,33,41,0) 100%)',
    height: (LOGO_TOP_DESKTOP * 2) + LOGO_HEIGHT_DESKTOP,
    width: '100%',
    position: 'absolute',
    top: 0,

    [screens.TABLET]: {
      height: (LOGO_TOP_TABLET * 2) + LOGO_HEIGHT_TABLET,
    },

    [screens.MOBILE]: {
      height: (LOGO_TOP_MOBILE * 2) + LOGO_HEIGHT_MOBILE,
    },
  },
});



// WEBPACK FOOTER //
// ./src/views/style.js